import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, Scale, Wand2 } from "lucide-react";
import { SEO } from "@/components/common/SEO";

export function Dashboard(){
  const {user,loading}=useAuth();
  if(loading) return <div className="p-12 text-muted-foreground">Loading…</div>;
  if(!user) return <Navigate to="/login" replace/>;
  const Card=({to,title,desc,icon:I,testId})=>(<Link to={to} data-testid={testId} className="rounded-3xl border border-border bg-card/30 p-6 hover:border-foreground/30 hover:-translate-y-1 transition-all"><div className="w-12 h-12 rounded-2xl bg-gradient-ai text-white grid place-items-center mb-4"><I className="w-5 h-5"/></div><div className="font-display text-xl">{title}</div><div className="text-sm text-muted-foreground mt-1">{desc}</div></Link>);
  return (<div className="max-w-6xl mx-auto px-6 lg:px-10 py-12" data-testid="dashboard-page">
    <SEO title="Your dashboard"/>
    <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Dashboard</div>
    <h1 className="font-display text-4xl sm:text-5xl mt-2 tracking-tighter">Hello, {user.name}.</h1>
    <p className="text-muted-foreground mt-3 max-w-xl">Your AI copilot for buying, owning and understanding cars.</p>
    <div className="mt-10 grid md:grid-cols-3 gap-5">
      <Card to="/advisor" title="AI Advisor" desc="Find your ideal car in 60s." icon={Wand2} testId="dash-advisor"/>
      <Card to="/compare" title="AI Compare" desc="Side-by-side + AI verdict." icon={Scale} testId="dash-compare"/>
      <Card to="/chat" title="AI Chat" desc="Ask anything about cars." icon={Sparkles} testId="dash-chat"/>
    </div>
    <div className="mt-10 rounded-3xl border border-border bg-card/30 p-6">
      <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Account</div>
      <div className="mt-3 text-sm"><span className="text-muted-foreground">Email:</span> {user.email}</div>
      <div className="mt-1 text-sm"><span className="text-muted-foreground">Role:</span> {user.role}</div>
    </div>
  </div>);
}
